const MEMBER_BASE_PATH = 'members/api/v1'
const TRAINER_BASE_PATH = 'trainers/api/v1'

export const API = {
  MEMBERS_API: {
    ACTIVITIES: `${MEMBER_BASE_PATH}/activities`,
    AI_CONVERSATION_REPORTS: `${MEMBER_BASE_PATH}/ai_conversation_reports`,
    CHECKUPS: `${MEMBER_BASE_PATH}/checkups`,
    EMAIL: `${MEMBER_BASE_PATH}/email`,
    EXERCISES: `${MEMBER_BASE_PATH}/exercises`,
    EXERCISE_RESULTS: `${MEMBER_BASE_PATH}/exercise_results/{exerciseId}`,
    EXERCISE_AVERAGE_STATS: `${MEMBER_BASE_PATH}/exercise_results/{exerciseId}/average_stats`,
    EXERCISE_TAGS: `${MEMBER_BASE_PATH}/exercise_tags`,
    HEALTH_GOAL_HISTORY: `${MEMBER_BASE_PATH}/health_goal/history?date={date}&id={healthGoalId}`,
    HEALTH_LIMITATIONS_SETS: `${MEMBER_BASE_PATH}/health_limitations_sets`,
    HOME_WORKOUT_FLOW: `${MEMBER_BASE_PATH}/home_workout_flow`,
    MEMBER_ACTIVITIES: `${MEMBER_BASE_PATH}/member_activities`,
    MEMBER_TRAINING_PLANS: `${MEMBER_BASE_PATH}/training_plans`,
    MEMBER_TRASH: `${MEMBER_BASE_PATH}/profile`,
    PASSWORDS: `${MEMBER_BASE_PATH}/passwords?current_password={currentPassword}&new_password={newPassword}`,
    PROFILE: `${MEMBER_BASE_PATH}/profile`,
    RESET_PASSWORD: `${MEMBER_BASE_PATH}/passwords/reset`,
    REQUEST_RESET_PASSWORD: `${MEMBER_BASE_PATH}/passwords/request_reset`,
    STATIONS: `${MEMBER_BASE_PATH}/stations`,
    SUPPORT_TICKETS: `${MEMBER_BASE_PATH}/support_tickets`,
    TRAINING_FREQUENCY_WEEKLY: `${MEMBER_BASE_PATH}/profile/weekly_training_frequency`,
    TRAINING_FREQUENCY_YEARLY: `${MEMBER_BASE_PATH}/profile/yearly_training_frequency`,
    TRAINING_PLANS: `${MEMBER_BASE_PATH}/training_plans`,
    TRAINING_STATUS: `${MEMBER_BASE_PATH}/training_status`,
    WORKOUTS: `${MEMBER_BASE_PATH}/workouts`,
    WORKOUT_ACTIVATE: `${MEMBER_BASE_PATH}/workouts/{workoutId}/activate?member_id={memberId}`,
    WORKOUT_RESULTS: `${MEMBER_BASE_PATH}/workout_results`,
    WORKOUT_RATE: `${MEMBER_BASE_PATH}/workout_results/rate`,
    MY_CLUB_SUMMARY: `${MEMBER_BASE_PATH}/club/stations_availability`,
    MY_CLUB_LEADERBOARD: `${MEMBER_BASE_PATH}/leaderboard`,
    HOME_WORKOUT_START: `${MEMBER_BASE_PATH}/home_workout_flow/start`,
    HOME_WORKOUT_NEXT_EXERCISE: `${MEMBER_BASE_PATH}/home_workout_flow/next_exercise`,
    HOME_WORKOUT_FINISH: `${MEMBER_BASE_PATH}/home_workout_flow/finish`,
    CURRENT_WORKOUT_STATION: `${MEMBER_BASE_PATH}/current_workout/station`
  },
  TRAINERS_API: {
    ACTIVITIES: `${TRAINER_BASE_PATH}/activities`,
    AI_CONVERSATION_REPORTS: `${TRAINER_BASE_PATH}/ai_conversation_reports`,
    BLOG_POSTS: `${TRAINER_BASE_PATH}/blog_posts`,
    FAVORITE_EXERCISES: `${TRAINER_BASE_PATH}/exercises/favorites`,
    FAVORITE_EXERCISE: `${TRAINER_BASE_PATH}/exercises/{exerciseId}/favorite`,
    BODY_MEASUREMENTS: `${TRAINER_BASE_PATH}/members/{memberId}/body_measurements`,
    BODY_MEASUREMENT_GOALS: `${TRAINER_BASE_PATH}/members/{memberId}/body_measurement_goals`,
    CHECKUPS: `${TRAINER_BASE_PATH}/members/{memberId}/checkups`,
    CLUB: `${TRAINER_BASE_PATH}/club`,
    CLUB_STATS: `${TRAINER_BASE_PATH}/club_stats`,
    CLUB_STATS_ACTIVE_MEMBERS: `${TRAINER_BASE_PATH}/club_stats/active_members`,
    CLUB_STATS_AVERAGE_INTENSITY_RATING: `${TRAINER_BASE_PATH}/club_stats/average_intensity_rating`,
    CLUB_STATS_INACTIVE_MEMBERS: `/inactive_members`,
    CLUB_STATS_NEW_MEMBERS: `/new_members`,
    CLUB_STATS_STATION_WORKOUTS: `${TRAINER_BASE_PATH}/club_stats/station_workouts`,
    CLASSES: `${TRAINER_BASE_PATH}/club_classes`,
    CLASSES_SHOW: `${TRAINER_BASE_PATH}/club_classes/{classId}/show`,
    CLASSES_HIDE: `${TRAINER_BASE_PATH}/club_classes/{classId}/hide`,
    CLASSES_TOGGLE_HIDDEN: `${TRAINER_BASE_PATH}/club_classes/{classId}/toggle_hidden`,
    EMAIL: `${TRAINER_BASE_PATH}/email`,
    EXERCISES: `${TRAINER_BASE_PATH}/exercises`,
    EXERCISE_RESULTS: `${TRAINER_BASE_PATH}/members/{memberId}/exercise_results/{exerciseId}`,
    EXERCISE_AVERAGE_STATS: `${TRAINER_BASE_PATH}/members/{memberId}/exercise_results/{exerciseId}/average_stats`,
    EXERCISE_TAGS: `${TRAINER_BASE_PATH}/exercise_tags`,
    GOALS: `${TRAINER_BASE_PATH}/goals`,
    HEALTH_GOAL: `${TRAINER_BASE_PATH}/members/{memberId}/health_goal`,
    HEALTH_GOAL_HISTORY: `${TRAINER_BASE_PATH}/members/{memberId}/health_goal/history?date={date}&id={healthGoalId}`,
    HEALTH_GOAL_INDICATORS: `${TRAINER_BASE_PATH}/members/{memberId}/health_goal_indicators`,
    HEALTH_GOALS: `${TRAINER_BASE_PATH}/health_goals`,
    HEALTH_LIMITATIONS_SETS: `${TRAINER_BASE_PATH}/members/{memberId}/health_limitations_sets`,
    MEMBERS: `${TRAINER_BASE_PATH}/members`,
    MEMBER_ACTIVATE: `${TRAINER_BASE_PATH}/members/{memberId}/activate?code_serial={codeSerial}`,
    MEMBER_ACTIVITIES: `${TRAINER_BASE_PATH}/members/{memberId}/member_activities`,
    MEMBERS_CONNECT_MOBILE: `${TRAINER_BASE_PATH}/members/move_member`,
    MEMBER_DEACTIVATE: `${TRAINER_BASE_PATH}/members/{memberId}/deactivate`,
    MEMBER_DETAILS: `${TRAINER_BASE_PATH}/members/{memberId}`,
    MEMBER_PERMISSIONS: `${TRAINER_BASE_PATH}/members/{memberId}/member_permissions`,
    MEMBERS_LATEST_ACTIVITY_DETAILS: `${TRAINER_BASE_PATH}/members/details`,
    MEMBER_TRAINING_PLANS: `${TRAINER_BASE_PATH}/training_plans`,
    MEMBER_TRASH: `${TRAINER_BASE_PATH}/members/{memberId}/trash`,
    MEMBER_WORKOUTS: `${TRAINER_BASE_PATH}/workouts?scope=member&member_id={memberId}`,
    MESSAGES: `${TRAINER_BASE_PATH}/member_notifications`,
    PASSWORDS: `${TRAINER_BASE_PATH}/passwords`,
    PROFILE: `${TRAINER_BASE_PATH}/profile`,
    RESET_PASSWORD: `${TRAINER_BASE_PATH}/passwords/reset`,
    REQUEST_RESET_PASSWORD: `${TRAINER_BASE_PATH}/passwords/request_reset`,
    STATIONS: `${TRAINER_BASE_PATH}/stations`,
    SUPPORT_TICKETS: `${TRAINER_BASE_PATH}/support_tickets`,
    TASKS: `${TRAINER_BASE_PATH}/tasks`,
    TRAINING_FREQUENCY_WEEKLY: `${TRAINER_BASE_PATH}/members/{memberId}/weekly_training_frequency`,
    TRAINING_FREQUENCY_YEARLY: `${TRAINER_BASE_PATH}/members/{memberId}/yearly_training_frequency`,
    TRAINING_PLANS: `${TRAINER_BASE_PATH}/training_plans`,
    TRAINING_STATUS: `${TRAINER_BASE_PATH}/members/{memberId}/training_status`,
    WORKOUT_ACTIVATE: `${TRAINER_BASE_PATH}/workouts/{workoutId}/activate?member_id={memberId}`,
    WORKOUT_TOGGLE_VISIBILITY: `${TRAINER_BASE_PATH}/workouts/{workoutId}/toggle_hidden`,
    WORKOUT_RESULTS: `${TRAINER_BASE_PATH}/members/{memberId}/workout_results`,
    WORKOUTS: `${TRAINER_BASE_PATH}/workouts`,
    WORKOUT_DETAILS: `${TRAINER_BASE_PATH}/workouts/{workoutId}`,
    CATEGORIES: `${TRAINER_BASE_PATH}/categories`,
    WORKOUT_CATEGORIES: `${TRAINER_BASE_PATH}/workouts/{workoutId}/categories`,
    SUPPORT_TICKETS_NOTIFICATIONS: `${TRAINER_BASE_PATH}/support_tickets_activities?page={page}&items_per_page={itemsPerPage}`,
    SUPPORT_TICKETS_NOTIFICATIONS_READ: `${TRAINER_BASE_PATH}/support_tickets_activities/{id}/read`,
    MY_CLUB_SUMMARY: `${TRAINER_BASE_PATH}/club/stations_availability`,
    MY_CLUB_LEADERBOARD: `${TRAINER_BASE_PATH}/leaderboard`,
    EMOJIS: `${TRAINER_BASE_PATH}/smileys`
  }
}
